// extracted by mini-css-extract-plugin
module.exports = {"container":"container___2W8ra","wrapper":"wrapper___30DaT","list":"list___2x8RM"};